<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title">{{ $t('merchant.title1') }}</h3>
				<div class="mt_20">
					<PaymentStatisticsChart
						ref="barChart"
						:range-date="rangeDate"
					></PaymentStatisticsChart>
				</div>
			</div>

			<div class="card">
				<h3 class="title">{{ $t('merchant.title2') }}</h3>
				<div>
					<DatePicker
						is-expanded
						is-range
						trim-weeks
						style="border: none"
						v-model="rangeDate"
						:locale="$store.state.common.locale"
					/>
				</div>
			</div>

			<div class="card mb_0">
				<h3 class="title">{{ $t('merchant.title4') }}</h3>
				<router-link
					:to="{ name: 'merchant-console-cs-notice' }"
					class="icon_position more"
				></router-link>
				<div>
					<ul class="notice">
						<li v-for="item in noticeList" :key="item.seq">
							<router-link :to="{ name: 'merchant-console-cs-notice' }">
								<p class="title">{{ item.title }}</p>
								<p class="date">
									{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
								</p>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/merchant.m.css';
import PaymentStatisticsChart from '@/components/PaymentStatisticsChart';
import { fetchFaqList, fetchFaqTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'Catalog.m',
	components: { PaymentStatisticsChart },
	data() {
		return {
			rangeDate: {
				start: this.$dayjs(new Date()).add(-7, 'd').toDate(),
				end: this.$dayjs(new Date()).toDate(),
			},
			noticeList: [],
			faqTypeList: [],
		};
	},
	computed: {
		faqNotice() {
			return this.faqTypeList.find(item => {
				return item.name.toLowerCase() === 'notice';
			});
		},
	},
	watch: {
		rangeDate: {
			handler(val) {
				this.rangeDate = val;
			},
			deep: true,
		},
	},
	methods: {
		init() {
			Promise.all([this.loadFaqTypeList()]).then(() => {
				this.loadNoticeList();
			});
		},
		async loadFaqTypeList() {
			const { data } = await fetchFaqTypes().catch(commonError);
			this.faqTypeList = data;
		},
		async loadNoticeList() {
			const params = {
				type_seq: this.faqNotice.seq,
				page_count: 3,
			};
			const { data } = await fetchFaqList(params).catch(commonError);
			this.noticeList = data;
		},
	},
	created() {
		this.init();
	},
};
</script>
